/*
 * @Author: xuxuiao 1985722833@qq.com
 * @Date: 2023-08-15 17:02:36
 * @LastEditors: Do not edit
 * @LastEditTime: 2024-05-11 11:19:02
 * @FilePath: \process-portal\src\store\modules\common.ts
 * @Description: 
 */
import { defineStore } from 'pinia'
import { getEmpOrgStationById } from '@/api/common';

export const commonStore = defineStore({
  id: 'common-store',
  state: () => ({ 
    // 所有人员信息
    personAllMap: {},
    // 系统信息
    nebulogyConfigInfo:{
      defaultHead: ''
    }
  }),
  actions: {
    /**
     * @FunctionName: 根据人员ID获取人员信息
     * @param {*}
     * @return {*}
     * @Author: zhuzhaoyang
     * @Date: 2023-09-27 17:18:12
     * @Description: 
     */    
    getEmployeeById(employeeId: string){
      return new Promise((resolve, reject) => {
        //  判断是否已经获取了人员数据
        if(this.personAllMap && (this.personAllMap as any)[employeeId]){
          resolve((this.personAllMap as any)[employeeId])
        } else {
          //  防止同时多次重复请求
          (this.personAllMap as any)[employeeId] = {}
          // 没有数据、调接口获取
          getEmpOrgStationById(employeeId).then((res: any) => {
            (this.personAllMap as any)[employeeId] = res;
            resolve(res)
          }).catch((err: any) => {
            reject(err)
          })
        }
      })
    },
    /**
     * @FunctionName: 设置系统信息
     * @return {*}
     * @Author: chenlei
     * @Date: 2024-05-11 11:22:02
     * @Description: 
     */    
    setNebulogyConfigInfo(val:any){
      this.nebulogyConfigInfo = val;
    }
  }
})